import { render, staticRenderFns } from "./KeyMeasurePage.vue?vue&type=template&id=31e0bffa&"
import script from "./KeyMeasurePage.vue?vue&type=script&lang=js&"
export * from "./KeyMeasurePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports